/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, string, func, shape, number,
} from 'prop-types';
import Button from '@material-ui/core/Button/Button';
import Grid from '@material-ui/core/Grid';
import CustomsCardWrapper from '../CustomsCardWrapper/CustomsCardWrapper';

const styles = (theme) => ({
    saveButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: '30px 0',
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
        },
    },
    button: {
        padding: '6px 20px',
        marginRight: 40,
        [theme.breakpoints.down('xs')]: {
            marginRight: 0,
        },
    },
    customsWrapper: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: '30px 0px',
    },
    messageImageContainer: {
        height: 'inherit',
    },
    image: {
        width: 'auto',
        minWidth: '100%',
        height: '100%',
    },
    imageContent: {
        height: 'inherit',
        width: '45%',
        paddingRight: '5%',
    },
    messageContentParent: {
        width: '45%',
        paddingLeft: '5%',
    },
    textArea: {
        resize: 'none',
        width: '100%',
        minHeight: '100%',
        padding: '15px 5px',
        outline: 'none',
        border: 'none',
        overflow: 'hidden',
    },
});
const CUSTOMS_VIEWS = {
    SELECT_IMAGE: 'photo',
    SELECT_MESSAGE: 'text',
    SELECT_IMAGE_AND_MESSAGE: 'both',
};
const ReviewCustom = ({
    classes, addCustomsCard, customsCard, customsCardType, croppedImage, message, customType, customData,
}) => (
    <>
        <Grid container className={classes.customsWrapper}>
            {CUSTOMS_VIEWS.SELECT_IMAGE === customsCardType
            &&            (
                <CustomsCardWrapper customsCard={customsCard} customType={customType} customData={customData}>
                    <img className={classes.image} src={croppedImage} alt="custom" />
                </CustomsCardWrapper>
            )}
            {CUSTOMS_VIEWS.SELECT_MESSAGE === customsCardType
            &&            (
                <CustomsCardWrapper customsCard={customsCard} customType={customType} customData={customData}>
                    <textarea
                        className={classes.textArea}
                        style={{ ...message?.style, fontSize: `${customData?.message_settings?.heading_font_size}pt` }}
                        value={message?.text}
                        readOnly
                    />
                </CustomsCardWrapper>
            )}
            {CUSTOMS_VIEWS.SELECT_IMAGE_AND_MESSAGE === customsCardType
            &&            (
                <CustomsCardWrapper customsCard={customsCard} customType={customType} customData={customData}>
                    <Grid container className={classes.messageImageContainer}>
                        <Grid item xs={6} className={classes.imageContent}>
                            <img className={classes.image} src={croppedImage} alt="custom" />
                        </Grid>
                        <Grid item xs={6} className={classes.messageContentParent}>
                            <textarea
                                className={classes.textArea}
                                style={{ ...message?.style, fontSize: `${customData?.message_settings?.heading_font_size}pt` }}
                                value={message?.text}
                                readOnly
                            />
                        </Grid>

                    </Grid>
                </CustomsCardWrapper>
            )}
        </Grid>
        <Grid item xs={12} className={classes.saveButton}>
            <Button variant="contained" color="primary" className={classes.button} onClick={addCustomsCard}>{customType === 'label' ? 'Add Label' : 'Add Hangtag'}</Button>
        </Grid>
    </>
);
ReviewCustom.propTypes = {
    classes: object.isRequired,
    customsCard: string.isRequired,
    addCustomsCard: func.isRequired,
    customsCardType: string.isRequired,
    croppedImage: string,
    message: shape({
        messageText: string,
    }).isRequired,
    customType: string.isRequired,
    customData: shape({
        content_area_width: number,
        content_area_height: number,
        message_image_settings: shape({
            image_width: number,
        }),
        message_settings: shape({
            heading_font_size: string,
        }),
    }).isRequired,
};
ReviewCustom.defaultProps = {
    croppedImage: null,
};
export default withStyles(styles)(ReviewCustom);
